var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowestPaidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.30163 22.9686C1.02653 22.9686 0 20.667 0 20.667C0 20.667 1.02653 18.3654 2.30163 18.3654H14.0975C13.7045 18.2303 13.361 17.9279 13.1864 17.5501L8.58318 8.34357C8.21553 7.55979 8.67156 6.50349 9.49424 6.23374L12.2754 5.27473V1.53457C12.2755 0.731148 13.0064 0.000149012 13.8098 0.000149012H15.3442C16.1476 0.000149012 16.8786 0.731148 16.8787 1.53457V5.27473L19.6598 6.23374C20.4824 6.50349 20.9385 7.55979 20.5709 8.34357L15.9676 17.5501C15.7648 17.9727 15.3683 18.2632 14.9127 18.3654H26.8524C28.1275 18.3654 29.154 20.667 29.154 20.667C29.154 20.667 28.1275 22.9686 26.8524 22.9686H2.30163Z",
    fill: "#00A35E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2919 19.9478C13.8159 19.8557 13.3924 19.5247 13.189 19.0847L8.58573 9.87814C8.21808 9.09435 8.67411 8.03806 9.49679 7.76831L12.2779 6.80929V3.06914C12.278 2.26571 13.009 1.53471 13.8124 1.53471H15.3468C16.1502 1.53471 16.8811 2.26571 16.8812 3.06914V6.80929L19.6623 7.76831C20.485 8.03806 20.9411 9.09435 20.5734 9.87814L15.9701 19.0847C15.6997 19.6481 15.0577 20.0093 14.4357 19.9478C14.3878 19.9493 14.3397 19.9493 14.2919 19.9478Z",
    fill: "#00A35E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.572 18.4126L9.96875 9.20606L13.8048 7.91149V3.06837H15.3392V7.91149L19.1753 9.20606L14.572 18.4126Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.3613L0 22.0984C0 20.8786 1.03048 19.8898 2.30163 19.8898H26.8524C28.1235 19.8898 29.154 20.8786 29.154 22.0984V22.3613C29.154 23.581 28.1235 24.5698 26.8524 24.5698H2.30163C1.03048 24.5698 0 23.581 0 22.3613Z",
    fill: "#00A35E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53519 21.4236V22.9581H27.6203V21.4236H1.53519Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowestPaidIcon);
export default __webpack_public_path__ + "static/media/lowestPaidIcon.aaeddfbbad1c7ab5c23eb8c689157235.svg";
export { ForwardRef as ReactComponent };